import React from "react";
import { FaCheck } from "react-icons/fa";
import CancelPresentationIcon from '@material-ui/icons/CancelPresentation';
import COLORS from "scss/colors.module.scss";
import styled from "styled-components";

export default function StarColorList({
  colors,
  onChange,
  value,
  size = "normal",
  type = "square",
  handleClose,
  colorYellow,
}) {
  return (
    <>
      <StyledDiv>
        <ColorRectange
          color="yellow"
          onChange={onChange}
          isSelected={value === 'yellow'}
          size={size}
          type={type}
          handleClose={handleClose}
        />
      </StyledDiv>
      <StyledDiv>
        {Object.entries(colors).map(([colorName], index) => (
          <ColorRectange
            key={index}
            color={colorName}
            onChange={onChange}
            isSelected={value === colorName}
            size={size}
            type={type}
            handleClose={handleClose}
          />
        ))}
        <StyledCancelIcon
          onClick={() => {
            onChange("");
            handleClose();
          }}
        />
      </StyledDiv>
    </>
  );
}

export function ColorRectange({
  color,
  onChange,
  isSelected = false,
  size = "normal",
  type = "square",
  isDefaultCursor = false,
  handleClose,

}) {
  return (
    <StyledColorDiv
      isDefaultCursor={isDefaultCursor}
      color={window.appStore.currentViewStore.getStarColumnHashValue(color).color}
      borderColor={window.appStore.currentViewStore.getStarColumnHashValue(color).borderColor}
      size={size}
      type={type}
      onClick={() => {
        onChange?.(color);
        handleClose();
      }}
    >
      {isSelected && (
        <FaCheck
          size={12}
          color={COLORS.PRIMARY_COLOR}
          style={{ alignSelf: "center" }}
        />
      )}
    </StyledColorDiv>
  );
}

const StyledDiv = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  max-height: 200px;
  margin: 5px 7px;
  max-width: 230px;
`;

const StyledColorDiv = styled.div`
  opacity: 0.8;
  margin: 1px;
  margin-bottom: 3px;
  box-shadow: inset 0 0 0 2px hsla(0, 0%, 0%, 0.05);
  display: flex;
  flex-direction: column;
  justify-content: center;
  ${(styledColorprop) => `
          width: ${styledColorprop.size === "normal" ? "23px" : "32px"};
          height: ${styledColorprop.size === "normal" ? "23px" : "32px"};
          border-radius: ${styledColorprop.type === "square" ? "3px" : "16px"};
          background-color: ${styledColorprop.color};
          cursor: ${styledColorprop.isDefaultCursor ? "default" : "pointer"};
  `};
  &:hover {
    ${(styledColorprop) => `
      box-shadow: inset 0 0 0 3px ${styledColorprop.borderColor};
    `};
  }
`;

const StyledCancelIcon = styled(CancelPresentationIcon)`
  font-size: 27px !important;
  margin-top: -1px;
  cursor: pointer;
`;